// CharityCard.jsx
import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Carousel } from "antd";
import { LeftCircleOutlined, RightCircleOutlined } from "@ant-design/icons";
import { fetchCauses } from "../../Redux/causesSlice";

const CharityCard = () => {
  const dispatch = useDispatch();
  const carouselRef = useRef(null);

  // Get causes and status from Redux store
  const { causes, status, error } = useSelector((state) => state.causes);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchCauses()); // Dispatch the action to fetch causes
    }
  }, [status, dispatch]);

  if (status === "loading") {
    return <div className="text-center">Loading...</div>;
  }

  if (status === "failed") {
    return <div className="text-red-500 text-center">{error}</div>;
  }

  return (
    <div className="relative">
      <Carousel
        ref={carouselRef}
        dots={false}
        arrows={false}
        autoplay
        responsive={[
          
          { breakpoint: 1024, settings: { slidesToShow: 4 } }, // Desktop (≥1024px)
          { breakpoint: 768, settings: { slidesToShow: 3 } }, // Tablet (≥768px)
          { breakpoint: 576, settings: { slidesToShow: 2 } }, // Small tablet (≥576px)
          { breakpoint: 480, settings: { slidesToShow: 1 } }, // Mobile (≥480px)
        ]}
        className="charity-carousel py-4 pb-4 h-auto mx-4 sm:mx-10 lg:mx-20"
      >
        {causes.map((cause) => (
          <div key={cause._id} className="px-2">
            <div
              className="p-0 shadow-md rounded-md bg-cover bg-center relative"
              style={{
                backgroundImage: `url("https://static.vecteezy.com/system/resources/thumbnails/015/031/626/small_2x/abstract-gradient-line-white-color-background-video.jpg")`,
              }}
            >
              <div className="bg-white bg-opacity-80 p-4 rounded-md text-center">
                <h5 className="mt-4 mb-2 text-lg font-medium">{cause.name}</h5>
                <p className="text-gray-600">{cause.slug}</p>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
      {/* Custom Arrows */}
      <button
        className="absolute top-1/2 left-0 transform -translate-y-1/2 text-2xl px-2 py-1 rounded-full bg-white shadow-md hover:shadow-lg focus:outline-none sm:top-16"
        onClick={() => carouselRef.current.prev()}
      >
        <LeftCircleOutlined />
      </button>
      <button
        className="absolute top-1/2 right-0 transform -translate-y-1/2 text-2xl px-2 py-1 rounded-full bg-white shadow-md hover:shadow-lg focus:outline-none sm:top-16"
        onClick={() => carouselRef.current.next()}
      >
        <RightCircleOutlined />
      </button>
    </div>
  );
};

export default CharityCard;
